import React from 'react'
import MyJobTable from './myJobTable'

const Content = () => {
    return (
        <div className="div-table margin-auto p-3">
            <MyJobTable />
        </div>
    )
}

export default Content